import React, { Component } from 'react';
import { Card, Table } from 'antd';
import DescriptionList from '@comm/DescriptionList';

import moment from 'moment';
import { queryFilePreview } from '@api/pub/attachment';

const { Description } = DescriptionList;

class CardInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    return [
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '附件',
        dataIndex: 'uuid',
        key: 'uuid',
        render: (text, record) => {
          return (
            <div>
              {(record.files || []).map(item => {
                return (
                  <a
                    key={item.uuid}
                    style={{ display: 'block' }}
                    onClick={() => queryFilePreview(item)}
                  >
                    {item.name}
                  </a>
                );
              })}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { data } = this.props;
    return (
      <Card>
        <DescriptionList size="large" col={1}>
          <Description term="完成时间">
            {data.completionDate ? moment(data.completionDate).format('YYYY-MM-DD HH:mm:ss') : ''}
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="完成备注">{data.completionRemark}</Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="完成附件">
            <Table
              rowKey="uuid"
              pagination={false}
              columns={this.columns()}
              dataSource={data.attachment}
            />
          </Description>
        </DescriptionList>
      </Card>
    );
  }
}

export default CardInfo;



// WEBPACK FOOTER //
// ./src/components/task/spTask/pageDetail/CardCompInfo.js